import { render, staticRenderFns } from "./EmailAliases.vue?vue&type=template&id=72c97f9d"
import script from "./EmailAliases.vue?vue&type=script&lang=js"
export * from "./EmailAliases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports